import WacUrlInfo from 'owa-attachment-wac/lib/types/WacUrlInfo';
import { ClientItemId } from 'owa-client-ids';
import { action } from 'satcheljs';

export const tryProcessSharePointLink = action(
    'tryProcessSharePointLink',
    (element: HTMLElement, itemId: ClientItemId) => ({
        element,
        itemId,
    })
);

export const tryUndoProcessSharePointLink = action(
    'tryUndoProcessSharePointLink',
    (elements: HTMLElement[]) => ({
        elements,
    })
);

export const previewLinkInSxS = action(
    'previewLinkInSxS',
    (wacUrlGetter: () => Promise<WacUrlInfo>, itemId: ClientItemId) => ({
        wacUrlGetter,
        itemId,
    })
);

export const addGenericLinkClickListener = action(
    'addGenericLinkClickListener',
    (element: HTMLElement) => ({
        element,
    })
);

export const addOpenDocumentPreviewEventListener = action(
    'addOpenDocumentPreviewEventListener',
    (element: HTMLElement, href: string, itemId: ClientItemId) => ({
        element,
        href,
        itemId,
    })
);
